import React, { useState, useCallback, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import SlickSlider from "react-slick";
import Swal from "sweetalert2";

import Grid from '@material-ui/core/Grid';

import {
  Wrapper,
  WrapperCategories,
  WrapperPartners,
  Products,
  Partners
} from "./styles";

import { Container } from "../../../components/design/layout/container";
import { Headline } from "../../../components/design/foundation/headline";
import Slider from "./carousel"
import ButtonSelectState from "../../../components/patterns/button-select-state";
import ProductBox from "../../../components/design/layout/product-box";
import PartnerBox from "../../../components/design/layout/partner-box";
import ScrollableCategories, { Category } from "../../../components/design/layout/scrollable-categories";

import CategorizationService from "../../../services/Categorization";
import PartnerService from "../../../services/Partner";
import OfferService from "../../../services/Offer";

import loadImage from "../../../utils/LoadImage";
import ProductLoader from "../../../components/design/layout/loader/product";
import PartnerLoader from "../../../components/design/layout/loader/partner";

function Home({ website }) {
  const [categorization, setCategorization] = useState([]);
  const [partners, setPartners] = useState([]);
  const [dayOffers, setDayOffers] = useState([]);
  const [activeOffers, setActiveOffers] = useState([]);

  // * Loading States
  const [isLoadingOffers, setIsLoadingOffers] = useState(true);
  const [isLoadingOffersDay, setIsLoadingOffersDay] = useState(true);
  const [isLoadingPartners, setIsLoadingPartners] = useState(true);

  const params = {
    dots: true,
    infinite: false,
    autoplay: false,
    slidesToShow: 2,
    slidesToScroll: 2,
    arrows: false
  };

  const params_partners = {
    dots: true,
    infinite: false,
    autoplay: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    centerMode: false,
    // centerPadding: "30px",
    className: "Partners",
  };

  const handleInitialInfos = useCallback(() => {
    const categorizationService = new CategorizationService();
    const partnerService = new PartnerService();
    const offerService = new OfferService();

    categorizationService.list().then((response) => {
      setCategorization(response.data.payload);
    }).catch(err => {
      Swal.fire({
        icon: "error",
        html: err.message,
        title: "",
      });
    });

    partnerService.listAllByCompany({ tag: 'destaque' }).then((response) => {
      setPartners(response.data.payload);
      setIsLoadingPartners((partner) => partner = false);
    }).catch(err => {
      Swal.fire({
        icon: "error",
        html: err.message,
        title: "",
      });
    });

    offerService.listOnUs({dayOfferSort: 1}).then((response) => {
      setDayOffers(response.data.payload);
      setIsLoadingOffersDay(false);
    }).catch(err => {
      Swal.fire({
        icon: "error",
        html: err.message,
        title: "",
      });
    });

    offerService.listActiveFromUser().then((response) => {
      setActiveOffers(response.data.payload);
      setIsLoadingOffers(false);
    });

  }, []);

  useEffect(() => {
    handleInitialInfos();
  }, [handleInitialInfos]);

  return (
    <Wrapper>

      <ButtonSelectState theme={website} title="Informe seu estado" link="/lista-estados" />

      <Container withContainer={true} className="ContainerTop" >
        {/* <ActivePromotions theme={website} link="/ofertas-ativas" /> */}
        <Slider />
      </Container>

      <WrapperCategories>
        <Headline
          type="medium"
          title="Categorias"
          withLink={true}
          linkText="Ver mais"
          link="/categories"
          textAlign="left"
          seeMoreColorLink={props => props.theme?.carrefour.colors.links.seeMore}
        />
        <ScrollableCategories>
          {categorization && categorization.slice(0, 6).map((item, i) => (
            <React.Fragment key={`${i}-${item.nome}`}>
              <Category
                title={item.nome}
                caregoriesBorderColor={props => props.theme?.carrefour.colors.categories.borderColor}
                category={item}
                categoryImage={loadImage({ imageCode: item.imagem })}
                params={`&tail=home`}
              />
            </React.Fragment>
          ))}
        </ScrollableCategories>

      </WrapperCategories>

      <Container withContainer={true} className="ContainerBottom">

        <Products>
          <Headline
            type="medium"
            title="Minhas ofertas ativas"
            withLink={true}
            linkText="Ver mais"
            link="/ofertas-ativas"
            textAlign="left"
            seeMoreColorLink={props => props.theme?.carrefour.colors.links.seeMore}
          />


          {isLoadingOffers ?
            (<Grid container spacing={0}>
              {[0, 1].map((num, index) =>
                <Grid key={num} item xs={6}>
                  <ProductLoader />
                </Grid>
              )}
            </Grid>) : (

              <SlickSlider {...params} className="ReactSlick">
                {activeOffers && activeOffers.map((item, i) => (
                  <React.Fragment key={`${i}-${item._id}`}>
                    <ProductBox
                      gridMargin={5}
                      productId={item._id}
                      discountValue={!item.descont ? item.descont : null}
                      productTitle={item.titulo}
                      image={loadImage({ imageCode: item.imagens[0] })}
                      productPrice={item.oferta}
                      productType={item.tipo_oferta}
                      priceColor={props => props.theme[website]?.components.productBox.priceColor}
                      announcedBy={item.empresa ? website : 'parceiro'}
                      company={website}
                    />
                  </React.Fragment>
                ))}
              </SlickSlider>
            )}
        </Products>

        <Products>
          <Headline
            type="medium"
            title="Ofertas do dia"
            withLink={true}
            linkText="Ver mais"
            link="/ofertas"
            textAlign="left"
            seeMoreColorLink={props => props.theme?.carrefour.colors.links.seeMore}
          />

          {isLoadingOffersDay ?
            (<Grid container spacing={0}>
              {[0, 1].map((num) =>
                <Grid key={num} item xs={6}>
                  <ProductLoader />
                </Grid>
              )}
            </Grid>) : (
              <SlickSlider {...params} className="ReactSlick">
                {dayOffers && dayOffers.slice(0, 10).map((item, i) => (
                  <React.Fragment key={`${i}-${item._id}`}>
                    <ProductBox
                      gridMargin={5}
                      productId={item._id}
                      discountValue={item.descont ? item.descont : null}
                      productTitle={item.titulo}
                      image={loadImage({ imageCode: item.imagens[0] })}
                      productPrice={item.oferta}
                      productType={item.tipo_oferta}
                      priceColor={props => props.theme[website]?.components.productBox.priceColor}
                      announcedBy={item.empresa ? website : 'parceiro'}
                      company={website}
                    />
                  </React.Fragment>
                ))}
              </SlickSlider>
            )}
        </Products>

        <WrapperPartners>
          <Partners>
            <Headline
              type="medium"
              title="Parceiros em alta"
              subTitle="Descontos para usar nas lojas parceiras"
              withLink={true}
              linkText="Ver mais"
              link="/parceiros"
              textAlign="left"
              seeMoreColorLink={props => props.theme?.carrefour.colors.links.seeMore}
            />

            {isLoadingPartners ?
              (<Grid container spacing={0}>
                {[0].map((num) =>
                  <Grid key={num} item xs={12}>
                    <PartnerLoader />
                  </Grid>
                )}
              </Grid>) : (

                <SlickSlider {...params_partners} className="ReactSlick">
                  {partners && partners.slice(0, 10).map((item, i) => (
                    <React.Fragment key={`${i}-${item.nome}`}>

                      <PartnerBox
                        title={item.nome}
                        cover={loadImage({ imageCode: item.imagem_banner })}
                        partnerLogo={loadImage({ imageCode: item.imagem_avatar })}
                        partnerId={item._id}
                        partnerUrl={item.website}
                      />
                    </React.Fragment>
                  ))}
                </SlickSlider>
              )}
          </Partners>
        </WrapperPartners>

      </Container>
    </Wrapper>
  )
}

const mapStateToProps = (state) => {
  return {
    scamber: state.scamberReducer.scamber,
    website: state.websiteReducer.website
  };
};

export default withRouter(connect(mapStateToProps)(Home));
